import React from 'react';
import { Flex, Modal, Typography, theme } from 'antd';

import type { GscActivationConflict } from './GscActivationErrors';

type Props = {
  conflicts: GscActivationConflict[] | null;
  confirmLoading: boolean;
  onConfirm: () => Promise<void>;
  onCancel: () => void;
};

function GscReplacePropertyModal({ conflicts, confirmLoading, onConfirm, onCancel }: Props) {
  const { token } = theme.useToken();

  return (
    <Modal
      title="Replace the synced property?"
      open={conflicts !== null}
      okText="Replace and sync"
      cancelText="Keep current setup"
      confirmLoading={confirmLoading}
      onOk={onConfirm}
      onCancel={onCancel}
    >
      <Flex vertical gap={token.marginXS}>
        {(conflicts ?? []).map((conflict) => (
          <Typography.Text key={conflict.domain}>
            {conflict.domain} is already synced from {conflict.existing_property_url}.
          </Typography.Text>
        ))}
        <Typography.Text>
          Replacing switches the sync to the property you selected. Search data already collected stays
          available.
        </Typography.Text>
      </Flex>
    </Modal>
  );
}

export default GscReplacePropertyModal;
